export default __webpack_public_path__ + "static/media/bitcoinDojoLogo.0c5b10ca.png";